module.exports = "/_next/static/images/62d9527c1aae244b703eeb0f6d3b5ee4-pj-man-in-denim-jacket@xl.jpg.webp";